module.exports = __webpack_public_path__ + "img/citas-evaluaciones-coordinadas.245ea197.svg";